module.exports = __webpack_public_path__ + "static/img/course_arrange_widget_1.c4f2a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_arrange_widget_1.png
// module id = Z+Kb
// module chunks = 11